import { defineComponent as _defineComponent } from 'vue'
import { GeoObject, GeoObjectBaseGeometry, GeoObjectType } from 'farmdok-rest-api';
import { computed, onMounted, ref } from 'vue';

import i18n from '@/initI18n';

import { Company } from '@/auth/store/types';
import ButtonLink from '@/shared/components/buttons/ButtonLink.vue';
import ButtonWithArrow from '@/shared/components/buttons/ButtonWithArrow.vue';
import FormFieldInput from '@/shared/components/form/FormFieldInput.vue';
import FormFieldSelect from '@/shared/components/form/FormFieldSelect.vue';
import FormFieldSet from '@/shared/components/form/FormFieldSet.vue';
import { createUuid } from '@/shared/modules/uuid';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapObjectsSidebar',
  props: {
    currentMapObject: null,
    objectType: null,
    geometry: null,
    companies: null,
    existingSubLayers: null
  },
  emits: ['onCancel', 'update:geoObjectEntry', 'save:geoObjectEntry', 'delete:geoObjectEntry'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  currentMapObject?: GeoObject;
  objectType: GeoObjectType;
  geometry?: GeoObjectBaseGeometry;
  companies: Company[];
  existingSubLayers: string[];
}

const $t = i18n.translate;

/* PROPS */



const geoObject = ref<GeoObject>({
  id: createUuid(),
  objectType:
    props.objectType === GeoObjectType.IsolationZone ? GeoObjectType.IsolationZone : GeoObjectType.MultiplierGroup,
  properties: {
    name: '',
    width: 0,
  },
  objectSubType: '',
} as GeoObject);

const companyId = ref();
const missingCompany = ref<boolean | null>(null);

/* LIFECYCLE */

onMounted(() => {
  if (props.currentMapObject) {
    geoObject.value = { ...props.currentMapObject };
  }

  if (geoObject.value.processOrderId) {
    companyId.value = props.companies.find((c) => c.processOrderId === geoObject.value.processOrderId)?.id;
  }
});

/* COMPUTED */

const titleString = computed(() => {
  switch (props.objectType) {
    case GeoObjectType.IsolationZone:
      return props.currentMapObject === null ? $t('Isolationszone erstellen') : $t('Isolationszone bearbeiten');
    case GeoObjectType.MultiplierGroup:
      return props.currentMapObject === null
        ? $t('Vermehrungsgemeinschaft erstellen')
        : $t('Vermehrungsgemeinschaft bearbeiten');
    default:
      return '';
  }
});

/* METHODS */

function onSave() {
  if (props.companies.length > 1 && !companyId.value) {
    missingCompany.value = true;
    return;
  }

  if (props.geometry) {
    geoObject.value.geometry = props.geometry as any;
  }

  // get company by companyId
  if (props.companies.length > 1) {
    const company = props.companies.find((c) => c.id === companyId.value);
    if (!company) {
      throw new Error(`company with id ${companyId.value} not found!`);
    }
    geoObject.value.processOrderId = company.processOrderId;
  } else {
    geoObject.value.processOrderId = props.companies[0].processOrderId;
  }

  if (props.currentMapObject) {
    emit('update:geoObjectEntry', { entry: geoObject.value });
  } else {
    emit('save:geoObjectEntry', { entry: geoObject.value });
  }
  onCancel();
}

function onDelete() {
  emit('delete:geoObjectEntry', { entry: geoObject.value });
  onCancel();
}

function onCancel() {
  emit('onCancel');
}

function updateCompanyId(value: string) {
  companyId.value = value;
  missingCompany.value = false;
}

/* EMITS */



expose({ onSave });

return { __sfc: true,$t, props, geoObject, companyId, missingCompany, titleString, onSave, onDelete, onCancel, updateCompanyId, emit, GeoObjectType, ButtonLink, ButtonWithArrow, FormFieldInput, FormFieldSelect, FormFieldSet }
}

})